// extracted by mini-css-extract-plugin
export var Container = "order-completed-module--Container--e7ff2";